export default function DaytonaStickyNav() {
  const links = [
    { href: "#processing-options", label: "Processing Times" },
    { href: "#services", label: "Services" },
    { href: "#local-area", label: "Daytona Beach" },
    { href: "#comparison", label: "Comparison" },
    { href: "#faq", label: "FAQ" },
    { href: "#local-resources", label: "Resources" },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="sticky top-0 z-40 bg-white border-b border-gray-200 overflow-x-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-1 py-2 min-w-max">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleClick(e, link.href)}
              className="text-gray-500 hover:text-[#1A365D] text-xs font-semibold px-3 py-2 rounded-md hover:bg-[#F7F8FA] transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}